<template lang="pug">
.g-header
  a.banner-top(:href="linkTop")
    //- バグ演出のためのリンク切れした画像
    img(src="aaiainanaeasdivaaaaa.png" width=375 height=97)
    .banner-top__caption
      | 44,??□,
      br
      | 四四??四百 <strong>万</strong>人が診断&lt;br
  .g-header__caption ���������
  a.logo(:href="linkYonimo" target="_blank")
    span 世にも奇妙な物語
</template>

<style lang="scss" scoped>
.g-header {
  background-color: #fff;
}

.g-header__caption {
  position: absolute;
  top: 30px;
  left: 0;
  margin: 8px;
  font-size: 12px;
}

.banner-top {
  position: relative;
  display: block;
  img {
    display: block;
  }
}
.banner-top__caption {
  position: absolute;
  top: 10px;
  left: 25px;
  line-height: 5px;
  text-decoration: underline;
  font-size: 12px;
  strong {
    font-size: 13px;
  }
}

.logo {
  position: absolute;
  top: 8px;
  right: 8px;
  display: block;
  width: (180px / 2);
  height: (160px / 2);
  background-image: image-url("yonimo-logo@2x.png");
  background-repeat: no-repeat;
  background-position: center;
  background-size: (164px / 2) (138px / 2);
  border: solid 1px #a3a3a3;
  span {
    display: none;
  }
}
</style>

<script>
import commonConfig from "@/mixin/commonConfig";
export default {
  name: "g-header",
  mixins: [commonConfig]
};
</script>
